// dep
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

// app
import { AppleConnection } from '../constants/apple-connection'
import { environment as ENV } from '@environment'

/**
 * Read-only access to the Apple Business Connect organizations mapped to a
 * group (`abc_companies`) and whether MapLabs can still reach them in Apple.
 */
@Injectable({
  providedIn: 'root'
})
export class AppleConnectionService {

  constructor(private http : HttpClient) {}

  /**
   * Every Apple organization mapped to `gid`, each checked live against Apple.
   * Resolves with an empty list when no organization is mapped.
   */
  async getConnections(gid : string) : Promise<AppleConnection[]> {
    const r = await this.http.get<{ data : AppleConnection[] | null }>(`${ENV.coreApiUrl}/abc/companies/status`,
                                                                        { params: { gid } }).toPromise()
    return r?.data || []
  }

}
